import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';

const SeatReleasePermission = ({
  id,
  status,
  seat,
  floor,
  selected,
  onToggle,
}) => {
  const isUsed = status === 'USED';

  const cardStyle = {
    cursor: isUsed ? 'default' : 'pointer',
    opacity: isUsed ? 0.45 : 1,
    border: selected ? '2px solid #007bff' : '1px solid #dee2e6',
    backgroundColor: selected ? '#e8f0fe' : '#fff',
    transition: 'border-color 0.15s, opacity 0.15s',
    userSelect: 'none',
    position: 'relative',
    textAlign: 'center',
    padding: '8px 6px',
    borderRadius: 8,
  };

  const handleKeyDown = (e) => {
    if (!isUsed && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onToggle(id);
    }
  };

  return (
    <div
      style={cardStyle}
      onClick={!isUsed ? () => onToggle(id) : undefined}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={isUsed ? -1 : 0}
    >
      <small className="text-muted d-block" style={{ fontSize: 10 }}>
        P{floor}
      </small>
      <strong style={{ fontSize: 20, lineHeight: '1.2' }}>{seat}</strong>
      <div className="mt-1">
        {isUsed ? (
          <Badge color="secondary" style={{ fontSize: 9 }}>
            Usado
          </Badge>
        ) : (
          <Badge color="success" style={{ fontSize: 9 }}>
            Activo
          </Badge>
        )}
      </div>
      {selected && (
        <div
          style={{
            position: 'absolute',
            top: 4,
            right: 4,
            width: 14,
            height: 14,
            borderRadius: 3,
            backgroundColor: '#007bff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <i className="fa fa-check" style={{ color: '#fff', fontSize: 8 }} />
        </div>
      )}
    </div>
  );
};

SeatReleasePermission.propTypes = {
  id: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  seat: PropTypes.number.isRequired,
  floor: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

SeatReleasePermission.defaultProps = {
  selected: false,
};

export default SeatReleasePermission;
